module.exports = __webpack_public_path__ + "img/04-3-1蓝图设计.d468927f.svg";